export class EliminationMatrixFilter {
  // public pageSize?: number; // how many thing to return at a time
  // public pageIndex?: number;
  public sortCriteria: SortCriteria; // if we need to support multiple maybe we make this a collection
  public filters: SearchFilterCriteria[]; // I think we just use this to build out and conditions for each FilterCriteria item
  public searchText: string;
}

export class SortCriteria {
  public ColumnName: string; // maybe this from an enum of possible entities to sort on?
  public isAscending: boolean; // true for ascending, false for descending
}

export class SearchFilterCriteria {
  public ColumnName: string; // maybe this from an enum of possible entities to sort on?
  public FilterCriteria: number; // maybe this is an enum of possible operators that match the UI>
  public FilterValue: string; // the value typed by the user
}
